export const ROOT = '/';

export const AUTH_ROUTES = {
    PATH: '/auth',
    SUB: {
        CU_001_00: 'login-or-signup',
        CU_001_01: 'signup',
        CU_001_02: 'confirm-signup-otp',
        CU_001_04: 'login',
        CU_001_05: 'confirm-login-otp',
        CU_026_01: 'reset-password',
        CU_027_01: 'confirm-reset-password-otp',
        CU_048_01: 'tutorial',
    },
};

export const PRIVATE_ROUTES = {
    PATH: '/app',
    SUB: {
        DASHBOARD: 'dashboard',
        CU_002_01: 'listed-properties',
        CU_002_02: 'dashboard',
        CU_002_03: 'buyer-transaction-details',
        CU_003_01: 'my-page',
        CU_003_02: 'pre-ekyc-information',
        CU_004_00: 'select-member-type',
        CU_004_01: 'regist-basic-individual-information',
        CU_005_01: 'regist-important-individual-information',
        CU_005_02: 'confirm-important-individual-information',
        CU_006_01: 'regist-basic-corporation-information',
        CU_007_01: 'accept-cic-agreement',
        CU_007_03: 'edit-corporation-information',
        CU_009_01: 'listing-property-details',
        CU_010_01: 'selling-time-check-simulation',
        CU_010_02: 'selling-time-check-simulation-result',
        CU_011_01: 'faq',
        CU_012_01: 'message',
        CU_012_02: 'chat-file-list',
        CU_013_01: 'register-bid-rice',
        CU_014_02: 'select-payment-method',
        CU_015_01: 'register-individual-property-purchase-form',
        CU_015_02: 'confirm-individual-property-purchase-form',
        CU_016_01: 'register-corporation-property-purchase-form',
        CU_016_02: 'confirm-corporation-property-purchase-form',
        CU_017_01: 'seller-transaction-details',
        CU_020_01: 'useful-content',
        CU_021_01: 'terms-of-service',
        CU_021_02: 'privacy-policy',
        CU_021_03: 'terms-of-privacy',
        CU_022_01: 'notification-list',
        CU_025_01: 'change-password',
        CU_028_01: 'search-property-for-assessment',
        CU_029_01: 'search-property-for-assessment-result',
        CU_029_02: 'property-inquiries',
        CU_030_01: 'property-detail',
        CU_031_01: 'register-room-infomation',
        CU_033_01: 'detailed-assessment-results',
        CU_035_01: 'request-assessment',
        CU_036_01: 'register-desired-upper-and-lower-price-limits',
        CU_036_02: 'detailed-property-after-appraisal',
        CU_043_01: 'documents-for-seller-settlement',
        CU_049_01: 'property-list',
        CU_049_02: 'property-details',
        CU_050_01: 'select-simulation-type',
        CU_051_01: 'cash-flow-simulation',
        CU_051_02: 'cash-flow-simulation-result',
        CU_052_01: 'loan-simulation',
        CU_052_02: 'loan-simulation-result',
        CU_053_01: 'break-even-simulation',
        CU_053_02: 'break-even-simulation-result',
        CU_054_01: 'mfa-setting',
        CU_055_01: 'search-property',
        CU_055_02: 'select-area',
        CU_055_03: 'select-filter-method',
        CU_055_04: 'search-property-by-areas',
        CU_055_05: 'search-property-by-stations',
        CU_056_01: 'select-assessment-method',
        CU_056_02: 'easy-assessment',
        CU_056_03: 'easy-assessment-sim-result',
        CU_057_01: 'property-location',
        CU_058_01: 'cash-flow-simulation-before-purchasing',
        CU_058_02: 'cash-flow-simulation-result-before-purchasing',
        CU_059_01: 'simulation-history',
        CU_059_02: 'simulation-comparison',
        CU_059_03: 'simulation-detail',
        CU_060_01: 'confirm-payment-details',
        CU_061_01: 'regist-fire-insurance',
        CU_062_01: 'regist-judicial-scrivener-datetime',
        CU_062_02: 'confirm-judicial-scrivener-datetime',
        CU_063_01: 'confirm-agency-contract',
        CU_065_01: 'notification-settings',
    },
};

export const TEMPLATE_ROUTES = {
    PATH: '/template',
    SUB: {
        ICONS: 'icons',
    },
};

export const MESSAGE_STATUS = {
    SUCCESS: '搬入済',
    NORMAL: '取消',
    WARNING: '未搬入',
    DANGER: '受け不可',
    BLUE: '新規作成',
};

export const NOTIFICATION_TITLE = {
    SUCCESS: 'カテゴリーが更新されました。',
    ERROR: 'エラーが発生しました',
    MESSAGE_DELETE_NOTIFICATION_SUCCESS: '通知を削除しました',
};

export const WEB_TYPE = {
    CU_021_01: 1,
    CU_021_02: 2,
    CU_011_01: 3,
    CU_020_01: 4,
    CU_021_03: 5,
};

export const ACCOUNT_RANK = {
    NORMAL: '10',
    GOLD: '30',
    PLATINUM: '40',
};

export const ACCOUNT_RANK_GROUP = {
    NOT_LOGIN: null,
    NORMAL_AND_HIGHER: [ACCOUNT_RANK.NORMAL, ACCOUNT_RANK.GOLD, ACCOUNT_RANK.PLATINUM],
    GOLD_AND_HIGHER: [ACCOUNT_RANK.GOLD, ACCOUNT_RANK.PLATINUM],
    PLATINUM: [ACCOUNT_RANK.PLATINUM],
};

export const PRIVATE_ROUTES_RANK: any[] = [
    {
        path: PRIVATE_ROUTES.SUB.CU_002_02,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_002_03,
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_050_01,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_013_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_015_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_015_02,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_016_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_016_02,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_022_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_025_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_028_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_029_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_049_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_029_02,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_030_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_058_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_058_02,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_061_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_062_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_062_02,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_060_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_063_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_031_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_035_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_033_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_036_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_036_02,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_002_01,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_009_01,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_014_02,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_010_01,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_010_02,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_055_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_049_02,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_051_01,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_051_02,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_052_01,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_052_02,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_054_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_055_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_055_02,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_055_03,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_055_04,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_055_05,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_053_01,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_053_02,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_057_01,
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_059_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_059_02,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_059_03,
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_017_01,
        ranks: ACCOUNT_RANK_GROUP.GOLD_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_043_01,
        ranks: ACCOUNT_RANK_GROUP.PLATINUM
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_004_00,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_004_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_006_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_007_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_007_03,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_003_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_011_01,
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_003_02,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_021_01,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_021_02,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_005_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_005_02,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_012_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_056_01,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_056_02,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_056_03,
        ranks: ACCOUNT_RANK_GROUP.NOT_LOGIN
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_012_02,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
    {
        path: PRIVATE_ROUTES.SUB.CU_065_01,
        ranks: ACCOUNT_RANK_GROUP.NORMAL_AND_HIGHER
    },
];
